import React from 'react';

import TextField from '@mui/material/TextField';

import { GITHUB_CONSTANTS } from '../plugin_constants';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import InputAdornment from '@mui/material/InputAdornment';
import CommonDrawerJs from '../CommonIntegrationDrawer';
import { GitHubSyncPassword } from '@api/api_services';
import { colors } from '@src/css_config/colorConstants';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { getEncryptData } from '@common/security';

const GitHubSyncronizeInstance = (props) => {
  const [showPassword, setShowPassword] = React.useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const emailId = JSON.parse(localStorage.getItem('test-optimize-user')).userName;
  const initialValues = {
    password: '',
  };
  const validationSchema = yup.object({
    password: yup.string().required('Password  is required'),
  });
  const handleSync = () => {
    if (formikDetails.values.password.trim() === '') {
      formikDetails.setFieldError('password', 'Password is required');
    } else {
      let payload = {
        gitHubUserName: props.data.gitHubUserName,
        gitHubAppPassword: getEncryptData(props.data.gitHubAppPassword),
        fireFlinkPassword: getEncryptData(formikDetails?.values?.password),
        organization: props.data.organization ? props.data.organization : 'N/A',
      };

      GitHubSyncPassword(payload, props?.data?.id).then((response) => {
        if (response?.data?.status === 'SUCCESS') {
          props.onClose();
          props.reloadTree();
          props.MyAlert.success(`${props.data.instanceName} ${response?.data?.message}`);
        } else if (response.data.responseCode === 400 && response.data.responseObject === null) {
          formikDetails.setFieldError('password', 'Invalid Password');
        } else if (response.data.responseCode === 400 && response.data.status.includes('Server Busy')) {
          props.onClose();
          props.MyAlert.warning(response?.data?.message);
        }
      });
    }
  };

  const formikDetails = useFormik({
    initialValues,
    validationSchema,
    onSubmit: handleSync,
  });
  return (
    <CommonDrawerJs
      isDrawerOpen={true}
      headerContent={`${GITHUB_CONSTANTS.SYNCHRONIZE_INSTANCE} - ${props?.data?.instanceName}`}
      drawerWidth="450px"
      rightButtonText="Sync"
      leftButtonText="Cancel"
      isLeftButtonVisible={true}
      onDrawerOpen={props.onClose}
      onRightButtonClick={handleSync}
      onLeftButtonClick={props.onClose}
    >
      <section className="w-full  flex flex-col justify-center items-center">
        <div className=" flex flex-col mt-2">
          <div className="integration-label fontPoppinsMediumSm">
            {
              <>
                {' '}
                <span className="text-red-600">*</span> {GITHUB_CONSTANTS.EMAIL}
              </>
            }
          </div>
          <div className="mt-2">
            <TextField
              className="instance-input-field w-auto"
              variant="outlined"
              name="name"
              autoComplete="off"
              placeholder="Enter Email"
              value={emailId}
              disabled={true}
              style={{ width: '420px', background: colors.rs_disabled_color }}
            />
          </div>
        </div>
        <div className="flex flex-col mt-2">
          <div className="integration-label fontPoppinsMediumSm">
            {
              <>
                {' '}
                <span className="text-red-600">*</span> {GITHUB_CONSTANTS.PASSWORD}
              </>
            }
          </div>
          <div className="mt-2">
            <TextField
              type={showPassword ? 'text' : 'password'}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <span aria-label="toggle password visibility" onClick={handleClickShowPassword}>
                      {showPassword ? (
                        <VisibilityOutlinedIcon className="mt-0 plugin-visibilityIcon" />
                      ) : (
                        <VisibilityOffOutlinedIcon className="mt-0 ml-2 plugin-visibilityIcon" />
                      )}
                    </span>
                  </InputAdornment>
                ),
              }}
              autoComplete="new-password"
              style={{ width: '420px' }}
              className="instance-input-field"
              placeholder="Enter Fireflink Password"
              name="password"
              value={formikDetails.values.fireflinkPassword}
              onChange={formikDetails.handleChange}
              onBlur={formikDetails.handleBlur}
              error={formikDetails.errors.password}
            />
          </div>
          {formikDetails.errors.password && (
            <div className="error-message mt-2 ml-2 fontPoppinsRegularXs">{formikDetails.errors.password}</div>
          )}
        </div>
      </section>
    </CommonDrawerJs>
  );
};

export default GitHubSyncronizeInstance;
